import React from "react";
import { FaSortAmountDownAlt, FaSortAmountUp, FaHashtag, FaClock } from "react-icons/fa";

export default function RouteFilterControls({
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
}) {
  const toggleSort = () => {
    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  const handleSortBy = (type) => setSortBy(type);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "8px",
        background: "#fff",
        border: "1px solid #e0e3eb",
        borderRadius: "8px",
        padding: "6px 10px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
        minHeight: "58px",
        fontFamily: "system-ui, sans-serif",
        transition: "all 0.2s ease",
      }}
    >
      {/* === Сортировка по полю === */}
      <div style={{ display: "flex", gap: "6px" }}>
        <button
          onClick={() => handleSortBy("createdAt")}
          style={{
            padding: "6px 12px",
            borderRadius: "6px",
            border: "1px solid #cbd3e1",
            background: sortBy === "createdAt" ? "#4a6cf7" : "#f9fafc",
            color: sortBy === "createdAt" ? "#fff" : "#1a1a2e",
            fontSize: "14px",
            cursor: "pointer",
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: "6px",
            transition: "all 0.2s ease",
          }}
        >
          <FaClock />
          По дате
        </button>

        <button
          onClick={() => handleSortBy("route_number")}
          style={{
            padding: "6px 12px",
            borderRadius: "6px",
            border: "1px solid #cbd3e1",
            background: sortBy === "route_number" ? "#4a6cf7" : "#f9fafc",
            color: sortBy === "route_number" ? "#fff" : "#1a1a2e",
            fontSize: "14px",
            cursor: "pointer",
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: "6px",
            transition: "all 0.2s ease",
          }}
        >
          <FaHashtag />
          По номеру
        </button>
      </div>

      {/* === Кнопка направления === */}
      <button
        onClick={toggleSort}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "6px 12px",
          borderRadius: "6px",
          border: "1px solid #cbd3e1",
          background: "#fff",
          color: "#1a1a2e",
          fontSize: "14px",
          cursor: "pointer",
          fontWeight: 500,
          whiteSpace: "nowrap",
          transition: "all 0.2s ease",
        }}
      >
        {sortOrder === "desc" ? (
          <>
            <FaSortAmountDownAlt color="#4a6cf7" />
            По убыванию
          </>
        ) : (
          <>
            <FaSortAmountUp color="#4a6cf7" />
            По возрастанию
          </>
        )}
      </button>
    </div>
  );
}
